export type State = {
  status: boolean;
  activeCustomer: any;
};
export const state: State = {
  status: false,
  activeCustomer: null,
};
